import { render, staticRenderFns } from "./Perfil.vue?vue&type=template&id=b43739ea&scoped=true&"
import script from "./Perfil.vue?vue&type=script&lang=js&"
export * from "./Perfil.vue?vue&type=script&lang=js&"
import style0 from "./Perfil.vue?vue&type=style&index=0&id=b43739ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43739ea",
  null
  
)

export default component.exports